import { Typography, Tabs, Tab } from '@mui/material';
import Header from '../../components/Header';
import { useTabHash } from '../../new/hooks/useTabHash';
import { keys } from '../../new/helpers/general';
import { useInfluencerAnalyticsTabs, tabs } from './useInfluencerAnalyticsTabs';
import { AnalyticsTabContent } from './AnalyticsTabContent';
import { InfluencerIdProvider } from '@client/new/contexts/InfluencerIdContext';
import { TitledPage } from '@client/new/components/Misc';

export const AnalyticsOverview = () => {
  const { tabHash, onTabChange } = useTabHash(keys(tabs), 'subscriptions');
  const analyticsTabs = useInfluencerAnalyticsTabs();

  return (
    <TitledPage title="Analytics">
      <main id="main">
        <div className="border-b border-gray-300">
          <Tabs value={tabHash} onChange={onTabChange}>
            {analyticsTabs.map(([hash, label]) => (
              <Tab key={hash} value={hash} label={label} iconPosition="start" />
            ))}
          </Tabs>
          <div className="py-6 bg-white p-5 border-gray-600 border-1">
            <AnalyticsTabContent hash={tabHash} />
          </div>
        </div>
      </main>
    </TitledPage>
  );
};

export function PlaybookAdminAnalyticsOverview() {
  return (
    <InfluencerIdProvider value={0}>
      <AnalyticsOverview />
    </InfluencerIdProvider>
  );
}
